import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="font-heading text-2xl text-primary-500 cursor-pointer">
              91牛
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              专业互联网服务平台，致力于为用户提供优质资源与高效解决方案。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/category/all" className="hover:text-primary-500 transition-colors cursor-pointer">
                资源中心
              </Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/tutorial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  使用教程
                </Link>
              </li>
              <li>
                <Link to="/category/feature" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  功能介绍
                </Link>
              </li>
              <li>
                <Link to="/category/activity" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  最新活动
                </Link>
              </li>
              <li>
                <Link to="/category/case" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  用户案例
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              <Link to="/about" className="hover:text-primary-500 transition-colors cursor-pointer">
                关于我们
              </Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about#intro" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#reputation" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  品牌信誉
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base" />
                <span>support@qx-ly.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-base" />
                <span>400-XXX-XXXX</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base" />
                <span>中国·北京</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 91牛 | 专业互联网服务平台 版权所有
          </p>
          <div className="flex items-center gap-2">
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="GitHub">
              <i className="ri-github-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}